import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function ManageCategories() {
  const token = localStorage.getItem('authToken');
  const [categories, setCategories] = useState([]);

  // form fields
  const [categoryId, setCategoryId] = useState(null);
  const [name, setName] = useState('');
  const [seoTitle, setSeoTitle] = useState('');
  const [seoDescription, setSeoDescription] = useState('');

  const fetchCategories = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/category`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCategories(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCategories();
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async () => {
    try {
      if (!categoryId) {
        // Create
        await axios.post(
          `${process.env.REACT_APP_API_URL}/api/admin/category`,
          { name, seoTitle, seoDescription },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        alert('Category created');
      } else {
        // Update
        await axios.put(
          `${process.env.REACT_APP_API_URL}/api/admin/category/${categoryId}`,
          { name, seoTitle, seoDescription },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        alert('Category updated');
      }
      setCategoryId(null);
      setName('');
      setSeoTitle('');
      setSeoDescription('');
      fetchCategories();
    } catch (err) {
      console.error(err);
      alert('Error submitting category');
    }
  };

  const handleEdit = (cat) => {
    setCategoryId(cat._id);
    setName(cat.name);
    setSeoTitle(cat.seoTitle || '');
    setSeoDescription(cat.seoDescription || '');
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure?')) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/admin/category/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('Category deleted');
      fetchCategories();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Manage Categories</h1>
      <div className="mb-6 space-y-2">
        <input
          type="text"
          placeholder="Category Name"
          className="border p-2 w-full max-w-sm"
          value={name}
          onChange={e => setName(e.target.value)}
        />
        <input
          type="text"
          placeholder="SEO Title"
          className="border p-2 w-full max-w-sm"
          value={seoTitle}
          onChange={e => setSeoTitle(e.target.value)}
        />
        <input
          type="text"
          placeholder="SEO Description"
          className="border p-2 w-full max-w-sm"
          value={seoDescription}
          onChange={e => setSeoDescription(e.target.value)}
        />
        <button
          onClick={handleSubmit}
          className="bg-primaryGreen text-white px-4 py-2 rounded hover:bg-green-500"
        >
          {categoryId ? 'Update Category' : 'Add Category'}
        </button>
      </div>

      <ul className="space-y-2">
        {categories.map(cat => (
          <li key={cat._id} className="border p-2 rounded flex justify-between">
            <div>
              <strong>{cat.name}</strong>
              <p className="text-sm text-gray-500">
                SEO Title: {cat.seoTitle || 'N/A'},
                SEO Desc: {cat.seoDescription || 'N/A'}
              </p>
            </div>
            <div className="space-x-2">
              <button
                onClick={() => handleEdit(cat)}
                className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
              >
                Edit
              </button>
              <button
                onClick={() => handleDelete(cat._id)}
                className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
